@if (!notFound && employee && goals) {
<div class="hub-user-profile-container">
    <div class="user-profile-header">
        <div class="avatar-panel">
            <div class="avatar" [ngStyle]="{'background-image': avatarUrl }">
                @if (avatarUrl === 'none') {
                <span class="initials">{{employee?.initials}}</span>
                }
            </div>
        </div>
        <div class="user-info-panel">
            <div class="change-user-panel">
                <app-change-user (userSelected)="newUserSelected($event)"></app-change-user>
            </div>
            <div class="user-name-panel">
                <div class="user-name">
                    <h1>
                        {{employee?.fullName}}
                        @if (!employee.isActive) {
                        <span> (Inactive)</span>
                        }
                    </h1>
                    @if (viewingOtherProfile) {
                    <div class="list-icons">
                        <div ngbDropdown placement="bottom-right">
                            <a id="dropdownBasic1" ngbDropdownToggle class="caret-0">
                                <i class="icon-menu9" style="font-size: 1.5em;"></i>
                            </a>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <a href="mailto:{{employee?.email}}" ngbDropdownItem>
                                    <i class="icon-envelop2"></i> E-mail
                                    {{employee?.firstNameOnlyDisplay}}
                                </a>
                                <a [href]="userDataService.generateTeamsUri(employee?.email)" ngbDropdownItem
                                    target="chat">
                                    <i class="icon-comment"></i> Start Teams chat
                                </a>
                                <a href="https://nam.delve.office.com/?p={{employee.email}}&v=work" target="_blank"
                                    ngbDropdownItem>
                                    <i class="icon-user"></i> Visit Profile
                                </a>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
        <div class="tabs-panel">
            <ul class="nav nav-tabs nav-tabs-top">
                <li class="nav-item">
                    <a href="#" (click)="setTabTo(tabs.work, $event)" [ngClass]="{active: activeTab === tabs.work}"
                        class="nav-link">{{possessivePronoun}} Work</a>
                </li>
                <li class="nav-item">
                    <a href="#" (click)="setTabTo(tabs.favorites, $event)"
                        [ngClass]="{active: activeTab === tabs.favorites}" class="nav-link">{{possessivePronoun}}
                        Favorites</a>
                </li>
                <li class="nav-item">
                    <a href="#" (click)="setTabTo(tabs.collections, $event)"
                        [ngClass]="{active: activeTab === tabs.collections}" class="nav-link">{{possessivePronoun}}
                        Collections</a>
                </li>
            </ul>
            <div class="flex-icon-container">
                <!-- @if (isAdmin || hasEditPermissions) {
            <div class="card-button-panel">
              <span class="btn flex-icon-container" (click)="openBulkEditWizard()">
                <i class="icon-gear"></i>
                <div class="bulk-edit-label">Bulk Edit</div>
              </span>
            </div>
          } -->
                @if (activeTab !== tabs.collections) {
                <div class="card-button-panel">
                    <span class="btn btn-icon legitRipple mr-1" [ngClass]="{'bg-teal': !showingListView}"
                        (click)="toggleListView()" matTooltipShowDelay="500"
                        [matTooltip]="(showingListView ? 'Show' : 'Hide') +  ' Cards'" id="ToggleListView">
                        <i class="icon-grid"></i>
                    </span>
                </div>
                }
            </div>
        </div>
    </div>
    <div class="user-profile-body">
        <div class="user-details-panel">
            <h3>{{possessivePronoun}} details</h3>
            <span class="d-block text-align-right mb-1">
                {{employee?.businessUnit.name}} <i matTooltip="Business Unit" matTooltipPosition="right"
                    class="icon-office ml-1 text-muted"></i>
            </span>
            <span class="d-block text-align-right mb-1">
                {{employee?.businessUnit?.division?.name}} <i matTooltip="Division" matTooltipPosition="right"
                    class="icon-users4 ml-1 text-muted"></i>
            </span>
            <span class="d-block text-align-right mb-1">
                <a href="mailto:{{employee?.email}}">{{employee?.email}}</a>
                <i matTooltip="Email" matTooltipPosition="right" class="icon-envelop2 ml-1 text-muted"></i>
            </span>
            <span class="d-block text-align-right mb-1">
                <div class="employee-app-roles-container">
                    <div [innerText]="employeeApplicationRoleDisplay"></div>
                    <i matTooltip="Hub Role" matTooltipPosition="right" class="icon-gear ml-1 text-muted"></i>
                </div>
            </span>
        </div>
        <div class="user-content-panel">
            @if (activeTab === tabs.work) {
            <div class="work-panel">
                <div class="title-and-filter-bar">
                    <h3>
                        <span>{{possessivePronoun}} conservation work</span>
                        @if (filteredProjects && filteredProjects.length) {
                        <span> ({{filteredProjects.length}})</span>
                        }
                    </h3>
                    @if (!viewingOtherProfile) {
                    <div class="filters">
                        @if (projectLists?.length > 1) {
                        <mat-form-field>
                            <mat-label>Records by Role:</mat-label>
                            <mat-select [disableOptionCentering]="true" [(value)]="currentProjectList"
                                panelWidth="250px">
                                @for (projectList of projectLists; track projectList) {
                                <mat-option [value]="projectList">
                                    {{projectList}} Projects</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        }
                        <mat-form-field>
                            <mat-label>Record Status</mat-label>
                            <mat-select [disableOptionCentering]="true" [(value)]="recordStatus">
                                @for (status of statuses; track status) {
                                <mat-option [value]="status">{{status.name}}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Last Updated</mat-label>
                            <mat-select [disableOptionCentering]="true" [(value)]="selectedDateRange">
                                @for (dateRange of dateRanges; track dateRange) {
                                <mat-option [value]="dateRange">{{dateRange.name}}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    }
                </div>
                <div class="results-panel hub-custom-scrollbar" [ngClass]="{'list-view': showingListView}">
                    <div class="card-columns">
                        @for (project of filteredProjects; track project.projectId) {
                        <div class="card card-record card-shadow border-blue 1"
                            [ngClass]="{'status-Canceled': project.status.name === 'Canceled'}">
                            <!-- Todo (ACE 2/25/2022) the project card itself should manage its own styles.  All the card classes above shouldn't need to be here -->
                            <app-project-card-graphql [project]="project" [showCardDetails]="true" [goals]="goals"
                                (switchTabToFavoritesRequested)="switchTabToFavoritesRequested()"
                                [isUserCanEdit]="isAllowedToEdit(project)">
                            </app-project-card-graphql>
                        </div>
                        }
                    </div>
                    @if (!projects) {
                    <app-modal-spinner></app-modal-spinner>
                    }
                </div>
            </div>
            }
            @if (activeTab === tabs.favorites) {
            <div class="favorites-panel">
                <h3>
                    {{possessivePronoun}} favorite conservation work
                    <app-help-selector [selector]="1151"></app-help-selector>
                </h3>
                <div class="results-panel hub-custom-scrollbar" [ngClass]="{'list-view': showingListView}">
                    <div class="card-columns">
                        @for (project of myFavoriteProjects; track project) {
                        <div class="card card-record card-shadow status-{{project?.status}}">
                            <app-project-card-graphql [project]="project" [isUserCanEdit]="isAllowedToEdit(project)"
                                (switchTabToFavoritesRequested)="switchTabToFavoritesRequested()" [goals]="goals"
                                [showCardDetails]="true">
                            </app-project-card-graphql>
                        </div>
                        }
                    </div>
                </div>
                @if (!myFavoriteProjects?.length) {
                <div class="alert alert-info alert-styled-left shadow-0">
                    @if (!employeeId || employeeId === userId) {
                    <span>
                        You currently do not have any Favorites registered.
                    </span>
                    }
                    @if (employeeId && employeeId !== userId) {
                    <span>
                        {{employee?.firstName}} currently does not have any Favorites registered.
                    </span>
                    }
                </div>
                }
            </div>
            }
            @if (activeTab === tabs.collections) {
            <div class="collections-panel">
                <h3>
                    {{possessivePronoun}} collections<app-help-selector [selector]="1150">
                    </app-help-selector>
                </h3>
                <div class="results-panel hub-custom-scrollbar">
                    <div class="card-columns">
                        @for (collection of myCollections; track collection; let i = $index) {
                        <app-collection-card [employeeId]="employeeId" [userId]="userId" [collection]="collection"
                            (deleteCollectionRequested)="deleteCollectionShowModal(collection.recordCollectionId, i)">
                        </app-collection-card>
                        }
                    </div>
                </div>
                @if (!myCollections || !myCollections.length) {
                <div class="alert alert-info alert-styled-left shadow-0">
                    @if (!employeeId || employeeId === userId) {
                    <span>
                        You currently do not have any Collections.
                    </span>
                    }
                    @if (employeeId && employeeId !== userId) {
                    <span>
                        {{employee?.firstNameOnlyDisplay}} currently does not have any Collections.
                    </span>
                    }
                </div>
                }
            </div>
            }
        </div>
    </div>
</div>
}

@if (notFound) {
<app-not-found></app-not-found>
}

@if (isBusy) {
<app-modal-spinner></app-modal-spinner>
}